import { render, staticRenderFns } from "./SortCheckboxTable.vue?vue&type=template&id=dd27a584&scoped=true"
import script from "./SortCheckboxTable.vue?vue&type=script&lang=js"
export * from "./SortCheckboxTable.vue?vue&type=script&lang=js"
import style0 from "./SortCheckboxTable.vue?vue&type=style&index=0&id=dd27a584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd27a584",
  null
  
)

export default component.exports